var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.456 10.154C21.579 10.813 21.646 11.502 21.646 12.221C21.646 17.845 17.882 21.844 12.197 21.844C10.9042 21.8444 9.62393 21.59 8.42943 21.0955C7.23492 20.6009 6.14957 19.8758 5.23539 18.9616C4.32121 18.0475 3.59612 16.9621 3.10155 15.7676C2.60699 14.5731 2.35263 13.2929 2.35303 12C2.35263 10.7072 2.60699 9.42691 3.10155 8.2324C3.59612 7.0379 4.32121 5.95255 5.23539 5.03837C6.14957 4.12419 7.23492 3.3991 8.42943 2.90453C9.62393 2.40997 10.9042 2.15561 12.197 2.15601C14.855 2.15601 17.076 3.13401 18.78 4.72201L16.005 7.49701V7.49001C14.972 6.50601 13.661 6.00101 12.197 6.00101C8.94903 6.00101 6.30903 8.74501 6.30903 11.994C6.30903 15.242 8.94903 17.992 12.197 17.992C15.144 17.992 17.15 16.307 17.562 13.993H12.197V10.154H21.457H21.456Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogoWhite);
export default __webpack_public_path__ + "static/media/googleLogoWhite.80a677c1627052b513e7fb68299a8df1.svg";
export { ForwardRef as ReactComponent };